module.exports = __webpack_public_path__ + "img/2010 winteressen 021.787bfad0.jpg";